import { createUniqueId } from '../../../lib/entity.js';
import * as defaultStreetObjects from './defaultStreets.js';

export function createSvgExtrudedEntity(position) {
  // This component accepts a svgString and creates a new entity with geometry extruded
  // from the svg and applies the default mixin material grass.
  const svgString = prompt(
    'Please enter string with SVG tag for create extruded entity',
    `<svg id="traffic-circle-svg" width="1562" height="1722" viewBox="0 0 1562 1722" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="747" cy="884" r="376" fill="white"/>
            <path d="M170 921C110.447 960.339 73.1658 978.46 0 1004L24 1070.5C87.6715 1053.2 126.721 1054.53 200.5 1070.5C180.691 1013.73 173.793 981.04 170 921Z" fill="white"/>
            <path d="M920.5 16.5L873 0C826.761 111.5 798.791 179.933 747 307.5C818.049 307.14 904.5 334 904.5 334C896.322 273.342 871.658 119.714 920.5 16.5Z" fill="white"/>
            <path d="M1562 797C1475.23 805.17 1419.94 800.652 1310 777C1322.14 822.934 1324.73 853.264 1326 911C1426.16 863.684 1479.82 844.12 1562 847V797Z" fill="white"/>
            <path d="M832 1467C782.879 1472.52 753.742 1472.69 697 1467C729.414 1550.35 751.819 1619.31 761 1722H803.5C806.545 1646.07 790.668 1543.99 832 1467Z" fill="white"/>
        </svg>`
  );
  if (svgString && svgString !== '') {
    const definition = {
      element: 'a-entity',
      components: {
        position: position ?? '0 0 0',
        'svg-extruder': `svgString: ${svgString}`,
        'data-layer-name': 'SVG Path • My Custom Path'
      }
    };
    AFRAME.INSPECTOR.execute('entitycreate', definition);
  }
}

export function createManagedStreetFromStreetmixURLPrompt(position) {
  // This creates a new Managed Street
  let streetmixURL = prompt(
    'Please enter a Streetmix URL',
    'https://streetmix.net/kfarr/3/3dstreet-demo-street'
  );

  if (streetmixURL && streetmixURL !== '') {
    const definition = {
      id: createUniqueId(),
      components: {
        position: position ?? '0 0 0',
        'managed-street': {
          sourceType: 'streetmix-url',
          sourceValue: streetmixURL,
          showVehicles: true,
          showStriping: true,
          synchronize: true
        }
      }
    };

    AFRAME.INSPECTOR.execute('entitycreate', definition);
  }
}

export function createManagedStreetFromStreetplanURLPrompt(position) {
  // This creates a new Managed Street
  let streetplanURL = prompt(
    'Please enter a StreetPlan URL',
    'https://streetplan.net/3dstreet/89474'
  );

  if (streetplanURL && streetplanURL !== '') {
    const definition = {
      id: createUniqueId(),
      components: {
        position: position ?? '0 0 0',
        'managed-street': {
          sourceType: 'streetplan-url',
          sourceValue: streetplanURL,
          showVehicles: true,
          showStriping: true,
          synchronize: true
        }
      }
    };

    AFRAME.INSPECTOR.execute('entitycreate', definition);
  }
}

export function createManagedStreetFromStreetObject(position, streetObject) {
  // This creates a new Managed Street
  if (streetObject && streetObject !== '') {
    const definition = {
      id: createUniqueId(),
      components: {
        position: position ?? '0 0 0',
        'managed-street': {
          sourceType: 'json-blob',
          sourceValue: JSON.stringify(streetObject),
          showVehicles: true,
          showStriping: true,
          synchronize: true
        }
      }
    };

    AFRAME.INSPECTOR.execute('entitycreate', definition);
  }
}

export function createStreetmixStreet(position, streetmixURL, hideBuildings) {
  // legacy
  // This code snippet allows the creation of an additional Streetmix street
  // in your 3DStreet scene without replacing any existing streets.
  if (streetmixURL === undefined) {
    streetmixURL = prompt(
      'Please enter a Streetmix URL',
      'https://streetmix.net/kfarr/3/3dstreet-demo-street'
    );
  }
  // position the street further from the current one so as not to overlap each other
  if (streetmixURL && streetmixURL !== '') {
    const definition = {
      id: createUniqueId(),
      components: {
        position: position ?? '0 0 -20',
        'streetmix-loader': {
          streetmixStreetURL: streetmixURL,
          showBuildings: !hideBuildings
        }
      }
    };

    AFRAME.INSPECTOR.execute('entitycreate', definition);
  }
}

export function create40ftRightOfWay(position) {
  createStreetmixStreet(
    position,
    'https://streetmix.net/3dstreetapp/1/40ft-right-of-way-24ft-road-width',
    true
  );
}
export function create60ftRightOfWay(position) {
  createStreetmixStreet(
    position,
    'https://streetmix.net/3dstreetapp/2/60ft-right-of-way-36ft-road-width',
    true
  );
}

export function create60ftRightOfWayManagedStreet(position) {
  console.log(
    'create60ftRightOfWayManagedStreet',
    defaultStreetObjects.stroad60ftROW
  );
  createManagedStreetFromStreetObject(
    position,
    defaultStreetObjects.stroad60ftROW
  );
}

export function create40ftRightOfWayManagedStreet(position) {
  console.log(
    'create40ftRightOfWayManagedStreet',
    defaultStreetObjects.stroad40ftROW
  );
  createManagedStreetFromStreetObject(
    position,
    defaultStreetObjects.stroad40ftROW
  );
}

export function create80ftRightOfWayManagedStreet(position) {
  console.log(
    'create80ftRightOfWayManagedStreet',
    defaultStreetObjects.stroad80ftROW
  );
  createManagedStreetFromStreetObject(
    position,
    defaultStreetObjects.stroad80ftROW
  );
}

export function create94ftRightOfWayManagedStreet(position) {
  console.log(
    'create94ftRightOfWayManagedStreet',
    defaultStreetObjects.stroad94ftROW
  );
  createManagedStreetFromStreetObject(
    position,
    defaultStreetObjects.stroad94ftROW
  );
}

export function create150ftRightOfWayManagedStreet(position) {
  console.log(
    'create150ftRightOfWayManagedStreet',
    defaultStreetObjects.stroad150ftROW
  );
  createManagedStreetFromStreetObject(
    position,
    defaultStreetObjects.stroad150ftROW
  );
}

export function createBuildingDemoManagedStreet(position) {
  console.log(
    'createBuildingDemoManagedStreet',
    defaultStreetObjects.buildingDemo
  );
  createManagedStreetFromStreetObject(
    position,
    defaultStreetObjects.buildingDemo
  );
}

export function create80ftRightOfWay(position) {
  createStreetmixStreet(
    position,
    'https://streetmix.net/3dstreetapp/3/80ft-right-of-way-56ft-road-width',
    true
  );
}
export function create94ftRightOfWay(position) {
  createStreetmixStreet(
    position,
    'https://streetmix.net/3dstreetapp/4/94ft-right-of-way-70ft-road-width',
    true
  );
}
export function create150ftRightOfWay(position) {
  createStreetmixStreet(
    position,
    'https://streetmix.net/3dstreetapp/5/150ft-right-of-way-124ft-road-width',
    true
  );
}

export function createCustomModel(position) {
  // accepts a path for a glTF (or glb) file hosted on any publicly accessible HTTP server.
  // Then create entity with model from that path by using gltf-model component
  const modelUrl = prompt(
    'Please enter a URL to custom glTF/GLB model',
    'https://cdn.glitch.global/690c7ea3-3f1c-434b-8b8d-3907b16de83c/Mission_Bay_school_low_poly_model_v03_draco.glb'
  );
  if (modelUrl && modelUrl !== '') {
    const definition = {
      class: 'custom-model',
      components: {
        position: position ?? '0 0 0',
        'gltf-model': `url(${modelUrl})`,
        'data-layer-name': 'glTF Model • My Custom Object',
        shadow: 'receive: true; cast: true;'
      }
    };
    AFRAME.INSPECTOR.execute('entitycreate', definition);
  }
}

export function createPrimitiveGeometry(position) {
  const definition = {
    'data-layer-name': 'Geometry • Circle Asphalt',
    components: {
      position: position ?? '0 0 0',
      geometry: 'primitive: circle; radius: 15;',
      rotation: '-90 -90 0',
      material: 'src: #asphalt-texture; repeat: 5 5;',
      shadow: ''
    }
  };
  AFRAME.INSPECTOR.execute('entitycreate', definition);
}

export function createImageEntity(position) {
  // This component accepts a svgString and creates a new entity with geometry extruded
  // from the svg and applies the default mixin material grass.
  const imagePath = prompt(
    'Please enter an image path that is publicly accessible on the web and starts with https://',
    `https://assets.3dstreet.app/images/signs/Sign-Speed-30kph-Kiritimati.png`
  );
  if (imagePath && imagePath !== '') {
    const definition = {
      element: 'a-entity',
      components: {
        position: position ?? '0 0 0', // TODO: How to override only the height (y) value? We don't want the sign in the ground
        geometry: 'primitive: plane; height: 1.5; width: 1;',
        material: `src: url(${imagePath})`,
        'data-layer-name': 'Image • User Specified Path'
      }
    };
    AFRAME.INSPECTOR.execute('entitycreate', definition);
  }
}

export function createIntersection(position) {
  const definition = {
    'data-layer-name': 'Street • Intersection 90º',
    components: {
      position: position ?? '0 0 0',
      intersection: '',
      rotation: '-90 -90 0'
    }
  };
  AFRAME.INSPECTOR.execute('entitycreate', definition);
}

export function createSplatObject(position) {
  // accepts a path for a .splat, .ply, or .spz file hosted on a CORS-enabled HTTP server.
  // Then create entity with model from that path by using splat component (Spark library)
  // Note: GitHub raw URLs don't work due to CORS. Use a CDN or CORS-enabled server.
  const modelUrl = prompt(
    "Enter URL to a Gaussian Splat (.splat, .ply, .spz)\n\nNote: Host must allow CORS. GitHub raw URLs won't work.",
    'https://sparkjs.dev/assets/splats/butterfly.spz'
  );

  if (modelUrl && modelUrl !== '') {
    const definition = {
      class: 'splat-model',
      'data-layer-name': 'Splat Model • My Custom Object',
      components: {
        position: position ?? '0 0 0',
        splat: `src: ${modelUrl}`
      }
    };
    AFRAME.INSPECTOR.execute('entitycreate', definition);
  }
}

export function createPanoramaSphere() {
  // Create a sphere with panorama texture for AR/VR experiences
  const panoramaUrl = prompt(
    'Please enter a URL to a 360° panorama image',
    'https://kfarr.github.io/ar-tour-assets/panoramic/world_b5da22ec-c745-40b3-ac6b-01247b8c212b_skybox.png'
  );

  if (panoramaUrl && panoramaUrl !== '') {
    const definition = {
      element: 'a-entity',
      components: {
        geometry:
          'primitive: sphere; radius: 100; segmentsWidth: 64; segmentsHeight: 32',
        material: `shader: flat; side: back; src: ${panoramaUrl}`,
        scale: '-1 1 1',
        'data-layer-name': 'Sphere Geometry • 360° Panorama'
      }
    };
    AFRAME.INSPECTOR.execute('entitycreate', definition);
  }
}

export function createModelFromFile(file, position) {
  // Create entity with model from a local file (blob URL)
  // Note: This is temporary and will not persist on reload
  if (file && file.name) {
    const blobUrl = URL.createObjectURL(file);
    const definition = {
      class: 'custom-model',
      components: {
        position: position ?? '0 0 0',
        'gltf-model': `url(${blobUrl})`,
        'data-layer-name': `glTF Model • ${file.name}`,
        'data-temporary-file': 'true',
        shadow: 'receive: true; cast: true;'
      }
    };
    AFRAME.INSPECTOR.execute('entitycreate', definition);
  }
}
